// REPLACE: src/helpers.js
//
// All /api calls go through authedFetch (attaches Firebase ID token).
// Server returns 429 { limitReached: true } when the authenticated user has
// exhausted their 10-chat monthly quota — askClaude surfaces that as a
// friendly string so the chat UI can render it in the bubble.

import { API_BASE } from './constants/colors';
import { authedFetch } from './firebase';
const trackDailyLimitHit = () => {};

export function fileToBase64(file) {
  return new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result.split(",")[1]); r.onerror = rej; r.readAsDataURL(file); });
}

export async function askClaude(messages, context = {}) {
  const endpoint = context.revision ? `${API_BASE}/api/revision` : `${API_BASE}/api/chat`;
  let res;
  try {
    res = await authedFetch(endpoint, {
      method: "POST",
      body: JSON.stringify({
        messages,
        studentClass: context.studentClass,
        board: context.board,
        lang: context.lang,
      }),
    });
  } catch (e) {
    // "Not logged in" from authedFetch falls here
    return context.lang === "hi"
      ? "कृपया साइन इन करें।"
      : "Please sign in to continue.";
  }

  // Server enforces the monthly 5-chat cap per-user. 429 = out of quota.
  if (res.status === 429) {
    let body = {};
    try { body = await res.json(); } catch {}
    if (body.limitReached) {
      trackDailyLimitHit();
      return context.lang === "hi"
        ? "आपने इस महीने के 10 AI chats पूरे कर लिए हैं। अगले महीने फिर आइए, और तब तक slides और flash cards से revise करें।"
        : "You've used all 10 AI chats this month. Come back next month, and meanwhile revise with slides and flash cards.";
    }
  }

  const data = await res.json().catch(() => ({}));
  return data.content?.[0]?.text || "...";
}

export async function extractProblemFromImage(base64, mediaType, lang) {
  const prompt = lang === "hi"
    ? "फोटो में सवाल का पूरा टेक्स्ट लिखें। सिर्फ सवाल।"
    : "Extract the full problem text. Just the problem, no explanation.";
  let res;
  try {
    res = await authedFetch(`${API_BASE}/api/extract`, {
      method: "POST",
      body: JSON.stringify({
        messages: [{
          role: "user",
          content: [
            { type: "image", source: { type: "base64", media_type: mediaType, data: base64 } },
            { type: "text", text: prompt },
          ],
        }],
      }),
    });
  } catch {
    return "";
  }
  const data = await res.json().catch(() => ({}));
  return data.content?.[0]?.text || "";
}
